module.exports = __webpack_public_path__ + "static/media/tanchuang.91a9784.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/tanchuang.mp3
// module id = 0Ayr
// module chunks = 1